module.exports = __webpack_public_path__ + "img/big_1_31.dc64a76b.png";